import { useEffect, useState } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { createPortal } from 'react-dom'
import { backdropVariants, panelVariants } from './style/popup'
import { XMarkIcon } from '@heroicons/react/24/solid'
import ownerPortalManager from './utils/ownerPortalManager'
import Login from './Stages/Login'
import Token from './Stages/Token'
import Manage from './Stages/Manage'
import { useSiteData } from '../../context/fetchContext'

const OwnerPortal = () => {
    const { refreshGallery } = useSiteData()

    useEffect(() => {
        ownerPortalManager.subscribe(setShowPopUp)
        return () => ownerPortalManager.unsubscribe()
    }, [])

    const [showPopUp, setShowPopUp] = useState(false)
    const [fullGalleryData, setFullGalleryData] = useState([])

    const [stage, setStage] = useState('login')
    const [token, setToken] = useState('')
    const [loading, setLoading] = useState(false)

    const util = {
        token,
        setToken,
        setStage,
        setLoading,
        fullGalleryData,
        setFullGalleryData
    }

    let page = <Login {...util} />
    if (stage === 'token') {
        page = <Token {...util} />
    } else if (stage === 'manage') {
        page = <Manage {...util} />
    }

    return (
        <>
            {showPopUp &&
                createPortal(
                    <>
                        <motion.div
                            initial='hidden'
                            animate='visible'
                            exit='hidden'
                            variants={backdropVariants}
                            className='fixed inset-0 z-[12] bg-gray-500 cursor-auto'

                        />
                        <div
                            className={`fixed inset-0 z-[12] flex min-h-full justify-center p-[1px] text-center items-center sm:p-0 `}

                        >
                            <motion.div
                                initial='hidden'
                                animate='visible'
                                exit='exit'
                                variants={panelVariants}
                                className={`justify-center flex-col bg-white rounded relative text-left`}
                                style={{
                                    pointerEvents: loading ? 'none' : 'auto',
                                    userSelect: loading ? 'none' : 'auto'
                                }}
                            >
                                <AnimatePresence>
                                    {loading && (
                                        <motion.div
                                            className="absolute z-[10] bg-gray-500 bg-opacity-50 w-full h-full flex items-center justify-center"
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                            exit={{ opacity: 0 }}
                                            transition={{ duration: 0.25, ease: "easeInOut" }}
                                        >
                                            <motion.div
                                                initial={{ scale: 0.8, opacity: 0 }}
                                                animate={{ scale: 1, opacity: 1 }}
                                                exit={{ scale: 0.8, opacity: 0 }}
                                                transition={{ duration: 0.25 }}
                                            >
                                                <svg
                                                    role="status"
                                                    aria-label="Loading"
                                                    width="48"
                                                    height="48"
                                                    viewBox="0 0 50 50"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <circle
                                                        cx="25"
                                                        cy="25"
                                                        r="20"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        strokeWidth="5"
                                                        strokeLinecap="round"
                                                        strokeDasharray="31.4 31.4"
                                                        transform="rotate(-90 25 25)"
                                                    >
                                                        <animateTransform
                                                            attributeName="transform"
                                                            type="rotate"
                                                            from="0 25 25"
                                                            to="360 25 25"
                                                            dur="0.9s"
                                                            repeatCount="indefinite"
                                                        />
                                                    </circle>
                                                </svg>
                                            </motion.div>
                                        </motion.div>
                                    )}
                                </AnimatePresence>
                                <div className='p-5'>
                                    <div className='flex justify-end'>
                                        <XMarkIcon
                                            width={30}
                                            className='hover:text-red-500 hover:opacity-100 opacity-50 transition ease-in-out duration-100 cursor-pointer'
                                            onClick={() => {
                                                setShowPopUp(false)
                                                setStage('')
                                                setToken('')
                                                refreshGallery()
                                            }}
                                        />
                                    </div>
                                    {page}
                                </div>
                            </motion.div>
                        </div>
                    </>,
                    document.getElementById('owner-portal')!!
                )
            }
        </>
    )
}

export default OwnerPortal